import { createSelector } from 'reselect';

import { PROJECTION } from 'constants/ApiConstants';
import { filterRequestFormatter } from 'modules/interventions/utils';
import { getProps, getRoot } from 'utils/selectors';

import { getUIState, getDashboardUIState, getReleaseByIds, getReleaseById } from '.';
import { RELEASE_STATE } from '../constants';

const getDashboardDataState = createSelector(getDashboardUIState, state => state.data);

const getCreationModalState = createSelector(getUIState, state => state.creationModal);

const getCreationModalLoadingState = createSelector(getCreationModalState, state => state.loading);

export const getReleaseIds = createSelector(getDashboardDataState, state => state.ids);

export const getPage = createSelector(getDashboardDataState, state => state.page);

export const loading = createSelector(getDashboardDataState, state => state.loading);

export const getFilters = createSelector(getDashboardUIState, state => state.filters);

export const getReleases = createSelector(getRoot, getReleaseIds, getReleaseByIds);

export const isModalCreationOpen = createSelector(getCreationModalState, state => state.open);

export const isCreating = createSelector(
  getCreationModalLoadingState,
  ({ fetch, ...loadingState }) => Object.values(loadingState).some(Boolean)
);

export const getEditingReleaseId = createSelector(getCreationModalState, uiState => uiState.releaseId);

export const getEditingRelease = createSelector(getRoot, getEditingReleaseId, getReleaseById);

export const getBaseRequestParams = createSelector(getPage, getFilters, ({ size, number }, filters) => {
  const { releaseStates, archived, ...formattedFilters } = filterRequestFormatter(filters);

  const defaultReleaseStates = archived ? Object.values(RELEASE_STATE) : [RELEASE_STATE.DRAFT, RELEASE_STATE.PUBLISHED];

  return {
    size,
    page: number,
    projection: PROJECTION.DETAILS,
    ...formattedFilters,
    releaseStates: releaseStates ?? defaultReleaseStates,
  };
});

export const isReleasePatching = createSelector(
  getDashboardUIState,
  getProps,
  (state, releaseId) => state.loading.patch.includes(releaseId),
);

const isReleaseDeleting = createSelector(
  getDashboardUIState,
  getProps,
  (state, releaseId) => state.loading.delete.includes(releaseId),
);

const getFetchingState = createSelector(getCreationModalLoadingState, state => state.fetch);

export const isFetchingRelease = createSelector(
  getFetchingState,
  getProps,
  (fetchingState, releaseId) => fetchingState.includes(releaseId),
);

export const isModalFetchingComplete = createSelector(
  getFetchingState,
  getEditingReleaseId,
  (fetchingState, releaseId) => !releaseId || !fetchingState.includes(releaseId),
);

export const isActionButtonLoading = createSelector(
  isReleasePatching,
  isFetchingRelease,
  isReleaseDeleting,
  (patching, fetching, deleting) => patching || fetching || deleting
);
